import React, { useState } from 'react';
import styled from 'styled-components';
import { keyType, StackPanel } from '@agilepoint/wat-react-ux';
import { useTranslate } from '@agilepoint/wat-react';
import { commonStyles, ElasticTextBoxField, websiteRegExp, emailRegExp } from 'common';
import { StyledRadioGroupField } from 'modules/create-new-app/components/app-wizard/styled-components';
import { useFormContext } from 'react-hook-form';
import { ICompanyDetailsFormFields } from './company-details';

const CompanyDetailsWrapper = styled(StackPanel)`
    ${commonStyles.boldTextLabel};
    overflow-y: auto;
    /* // Note: temp code needs to be fixed later  */
    padding: 0 20%;
`;

export const CompanyDetailsForm = React.memo(() => {
    const translate = useTranslate();
    const { watch, setValue } = useFormContext<ICompanyDetailsFormFields>();

    const eulaRadioOptions = [
        {
            name: 'Standard EULA',
            value: 'standardEULA',
            title: 'Standard EULA',
            key: 'standardEULA'
        },
        {
            name: 'Custom EULA',
            value: 'customEULA',
            title: 'Custom EULA',
            key: 'customEULA'
        }
    ];

    const [isCustomEula, setIsCustomEula] = useState(watch('eulaOptions') !== 'standardEULA');

    const onValueChange = React.useCallback((selectedKey: keyType) => {
        if (selectedKey === 'customEULA') {
            setIsCustomEula(true);
        }
        else {
            setIsCustomEula(false);
            setValue('eulaText', '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
            setValue('eulaLink', '', { shouldDirty: true, shouldTouch: true, shouldValidate: true });
        }
    }, [setValue]);

    return (
        <CompanyDetailsWrapper orientation='vertical' width="660px" gap="20" height="calc(100% - 60px)">
            <ElasticTextBoxField name="companyName" label={translate('modules.defaultAppSettings.companyDetails.companyName')} title={translate('modules.defaultAppSettings.companyDetails.companyName')} />
            <ElasticTextBoxField name="companyWebsite" label={translate('modules.defaultAppSettings.companyDetails.companyWebsite')} title={translate('modules.defaultAppSettings.companyDetails.companyWebsite')}
                validationRules={{
                    pattern: { value: websiteRegExp, message: translate('modules.createNewApp.steps.basicSettings.validationMessages.validSiteUriText') }
                }} />
            <ElasticTextBoxField name="companySupportEmail" label={translate('modules.defaultAppSettings.companyDetails.companySupportEmail')} title={translate('modules.defaultAppSettings.companyDetails.companySupportEmail')}
                validationRules={{
                    pattern: { value: emailRegExp, message: translate('modules.createNewApp.steps.basicSettings.validationMessages.validEmailIdText') }
                }} />
            <ElasticTextBoxField name="companyInfoEmail" label={translate('modules.defaultAppSettings.companyDetails.companyInfoEmail')} title={translate('modules.defaultAppSettings.companyDetails.companyInfoEmail')}
                validationRules={{
                    pattern: { value: emailRegExp, message: translate('modules.createNewApp.steps.basicSettings.validationMessages.validEmailIdText') }
                }} />
            <ElasticTextBoxField name="copyrightInfo" label={translate('modules.defaultAppSettings.companyDetails.copyrightInfo')} title={translate('modules.defaultAppSettings.companyDetails.copyrightInfo')} />
            <StyledRadioGroupField groupName="eula-options"
                options={eulaRadioOptions}
                onValueChange={onValueChange}
                name="eulaOptions" defaultSelectedKey="" />
            {isCustomEula ?
                <>
                    <ElasticTextBoxField
                        title="EULA Text"
                        label="EULA Text"
                        name="eulaText"
                        width='100%'
                    /> <ElasticTextBoxField
                        title={translate('modules.createNewApp.steps.basicSettings.eulaLink')}
                        label={translate('modules.createNewApp.steps.basicSettings.eulaLink')}
                        name="eulaLink"
                        width='100%'
                        validationRules={{
                            pattern: { value: websiteRegExp, message: translate('modules.createNewApp.steps.basicSettings.validationMessages.validSiteUriText') }
                        }} />
                </> : <></>}

        </CompanyDetailsWrapper>
    );
});
